/**
 * 샵관리 — 월손익 (관리회계)
 * 영업이익 = 매출 − 매출원가(시술·판매로 실제 쓴 FIFO 원가) − 재고손실(폐기·조정) − 월 고정비
 * 당월 매입액은 현금흐름 참고용이며 손익에는 넣지 않는다(쓴 만큼만 원가).
 */
import React, { useMemo, useState } from 'react';
import { PageContainer } from 'styles/common.styles';
import useTenantCode from 'hooks/useTenantCode';
import { monthlyPnl, thisYm, fmt } from 'shop/shopStore';
import { Cards, Card, Table, MonthBar } from 'shop/shopReportUi';

const MonthlyPnl = () => {
  const tc = useTenantCode();
  const [ym, setYm] = useState(thisYm());
  const valid = /^\d{6}$/.test(ym);
  const pnl = useMemo(() => (valid ? monthlyPnl(tc, ym) : null), [tc, ym, valid]);

  return (
    <PageContainer>
      <MonthBar ym={ym} setYm={setYm} />
      {!pnl ? (
        <div style={{ padding: 12, fontSize: 12 }}>귀속월을 YYYYMM 6자리로 입력하세요.</div>
      ) : (
        <>
          <Cards>
            <Card label="매출" value={pnl.revenue} sub={`${pnl.saleCount}건`} />
            <Card label="매출원가" value={pnl.cogs} sub="시술·판매 출고 원가" />
            <Card label="월 고정비" value={pnl.expense} />
            <Card label="영업이익" value={pnl.operatingProfit} strong negative={pnl.operatingProfit < 0} />
          </Cards>
          <Table
            head={['항목', '금액', '비고']}
            rows={[
              ['매출 (환불 제외)', pnl.revenue, `${pnl.saleCount}건 · 시술 ${pnl.recordCount}건`],
              ['(−) 매출원가', pnl.cogs, '시술사용·제품판매 출고 (FIFO 원가 확정값)'],
              ['매출총이익', pnl.grossProfit, ''],
              ['(−) 재고손실', pnl.loss, '폐기·재고조정 출고'],
              ...pnl.byCategory.map((c) => [`(−) ${c.label}`, c.amount, c.category === 'UTIL'
                ? pnl.utilDetail.map((u) => `${u.label} ${fmt(u.amount)}`).join(' · ') : '']),
              ['영업이익', pnl.operatingProfit, ''],
            ]}
            strongRows={[2, 4 + pnl.byCategory.length]}
          />
          <div style={{ fontSize: 12, color: '#5b6472', padding: '6px 2px' }}>
            참고) 당월 매입액(입고금액): ₩{fmt(pnl.purchase)} — 현금흐름 확인용이며 손익에는 포함하지 않습니다.
          </div>
        </>
      )}
    </PageContainer>
  );
};

export default MonthlyPnl;
